import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { ICompanyProductAuthItem, IProductCompanyEnabledProxy, ISaveServerProduct, IServerProductConfig, IServerProductItem, IServerProductParam } from '../../types/crowd-source/product';
import { EProxyPayType, ETaxSourceType } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 众包灵工 - 产品管理分页查询
 */
export async function queryServerProdctPage(param: IServerProductParam) {
  let data = [] as IServerProductItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IServerProductParam;

  try {
    const { code, context, message } = await Http.post<{ data: IServerProductItem[]; total: number }>(`${hostUrl}/side/server/product/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IServerProductItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 众包灵工 - 产品管理详情查询
 */
export async function queryServerProdctDetail(id: number, isCompany: boolean = false, isAgent: boolean = false) {
  let data = {} as IServerProductConfig;

  try {
    const { code, context, message } = await Http.post<IServerProductConfig>(`${hostUrl}/side/server/product/detail${isCompany ? '/company' : isAgent ? '/agent' : ''}`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IServerProductConfig;

      data = items || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 众包灵工 - 产品管理保存
 */
export async function saveServerProdct(params: ISaveServerProduct) {
  let data = {} as IServerProductConfig;

  try {
    const { code, context, message } = await Http.post<IServerProductConfig>(`${hostUrl}/side/server/product/config`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IServerProductConfig;

      data = items || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 众包灵工 - 产品管理 - 启用、停用
 */
export async function changeServerProductStatus(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/product/enable`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询企业端产品授权列表
 */
export async function queryCompanyProductAuthList(param: {dutyType?: number; authStatus?: number; proxyPayType?: EProxyPayType;taxSourceType?: ETaxSourceType }) {
  try {
    const { code, context, message } = await Http.post<ICompanyProductAuthItem[]>(
      `${hostUrl}/side/agent/product/auth/listByCompany`, param,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询企业产品授权列表
 */
export async function queryAllProductAuthList(params: any) {
  try {
    const { code, context, message } = await Http.post<ICompanyProductAuthItem[]>(
      `${hostUrl}/side/agent/product/auth/list`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 产品管理 - 删除
 */
export async function deleteServerProduct(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/product/delete`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 产品管理 - 查询可创建的任务类型
 */
export async function queryProductCompanyEnabledProxy() {
  try {
    const { code, context, message } = await Http.post<IProductCompanyEnabledProxy>(
      `${hostUrl}/side/agent/product/auth/enabled-proxy`, {},
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || {} as IProductCompanyEnabledProxy;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 众包灵工 - 产品管理 - 众包 - 查询企业的实际可用的开票方式
 */
export async function queryProductEnabledInvoiceMethod(params: { id?: number;productType?: 0 | 1}) {
  try {
    const { code, context, message } = await Http.post<string[]>(
      `${hostUrl}/side/agent/product/auth/get-enabled-invoice-method`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

